import type { DepartmentWidget, WidgetType } from '../../types';

const titles: Record<WidgetType, { ar: string; en: string; icon: string }> = {
  stats_card: { ar: 'ملخص الشعبة', en: 'Department summary', icon: 'ChartNoAxesCombined' },
  document_list: { ar: 'المستندات', en: 'Documents', icon: 'Files' },
  recent_activity: { ar: 'آخر النشاطات', en: 'Recent activity', icon: 'Activity' },
  storage_meter: { ar: 'مساحة Google Drive', en: 'Google Drive storage', icon: 'HardDrive' },
  search_bar: { ar: 'البحث', en: 'Search', icon: 'Search' },
  quick_actions: { ar: 'الإجراءات السريعة', en: 'Quick actions', icon: 'Zap' },
  notifications: { ar: 'التنبيهات', en: 'Notifications', icon: 'Bell' },
  category_filter: { ar: 'التصنيفات', en: 'Categories', icon: 'Tags' },
  custom_html: { ar: 'بطاقة مخصصة', en: 'Custom card', icon: 'PanelTop' },
  drive_status: { ar: 'حالة الربط', en: 'Drive connection', icon: 'Cloud' },
};

export function createWidget(type: WidgetType, order = 0): DepartmentWidget {
  const title = titles[type];
  return {
    id: crypto.randomUUID(),
    type,
    titleAr: title.ar,
    titleEn: title.en,
    icon: title.icon,
    size: type === 'document_list' || type === 'search_bar' || type === 'category_filter' ? 'full' : 'medium',
    order,
    visible: true,
    locked: type === 'document_list',
    config: {},
  };
}

export function defaultDepartmentWidgets(): DepartmentWidget[] {
  return [
    createWidget('stats_card', 0),
    createWidget('storage_meter', 1),
    createWidget('drive_status', 2),
    createWidget('quick_actions', 3),
    createWidget('search_bar', 4),
    createWidget('category_filter', 5),
    createWidget('document_list', 6),
    createWidget('recent_activity', 7),
  ];
}

export const widgetCatalogue = (Object.keys(titles) as WidgetType[]).map(type => ({ type, ...titles[type] }));
